<template>
  <div class="tripFilter-panel">
    <van-popup
      v-model="isShow"
      :close-on-popstate="true"
      position="right"
      class="full-width full-height"
    >
      <div>
        <ld-header
          @click-left="toggle"
          :right-text="$t('B016','恢复默认')"
          @click-right="init"
        >
          {{ $t('C121','筛选') }}
        </ld-header>

        <van-row
          type="flex"
          align="center"
          class="pad"
        >
          <van-col span="6">
            单据状态
          </van-col>
          <van-col span="18">
            <div
              class="filter-right-item "
              v-for="(item,index) in applyStatusArr"
              :key="index"
              @click="chooseApplyWay(index)"
              :class="index == indexStatus ? 'active': 'main-color'"
            >
              {{ item }}
            </div>
          </van-col>
        </van-row>

        <van-row
          type="flex"
          align="center"
          class="pad"
        >
          <van-col span="6">
            {{ $t('F217','日期类型') }}
          </van-col>
          <van-col span="18">
            <div class="filter-right">
              <span
                class="filter-right-item"
                v-for="(item,index1) in dateType"
                :key="index1"
                @click="chooseDateType(index1)"
                :class="index1 == indexDateType ? 'active' : ''"
              >{{ item }}</span>
            </div>
          </van-col>
        </van-row>
        <van-field
          :label="$t('F220','日期始')"
          readonly
          v-model="startDate"
          @click="showDate"
        />
        <van-field
          :label="$t('F221','日期止')"
          readonly
          v-model="endDate"
          @click="showDate"
        />
        <van-field
          :label="$t('F006','出行人')"
          clearable
          v-model="person"
          placeholder="请输入出行人/目的地"
        />

        <!--  -->
        <ld-tabbar class="pad-lr-8">
          <ld-button
            main
            size="lg"
            @click="confirmFilter"
          >
            {{ $t('B015','搜索') }}
          </ld-button>
        </ld-tabbar>
      <!--  -->
      </div>

      <Ld-calendar
        ref="date"
        type="range"
        @selected="getDate"
        start-text="起"
        end-text="止"
      />
    <!--  -->
    </van-popup>
  </div>
</template>
<script>
import {Popup,Field,Cell} from 'vant'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import { formatDate } from 'Utils/dateUtil'


export default {
  name: 'ApplyListFilter',
  components:{
    [Popup.name]:Popup,
    [Field.name]:Field,
    [Cell.name]:Cell,
    ldButton,
    ldTabbar,
    LdCalendar: () => import('Common/ldCalendar'),
  },
  data: function() { 
    return {
      wayArr: ['飞机', '火车', '其他'],
      applyStatusArr: ['全部', '草稿', '审批中', '审批通过', '审批拒绝', '报销中', '已报销'],
      dateType: ['申请日期', '出差日期'],
      startDate: '',
      endDate: '',
      person: '',
      //  被选中索引  默认索引
      indexWay: 0,
      indexStatus: 0,
      indexDateType: 1,
      isShow:false,
      minDate:formatDate(new Date(), -270).date,
      maxDate:formatDate(new Date(), 90).date,
    }
  },
  methods: {
    // 初始化 过滤条件
    init() {
      this.indexStatus = 0
      this.indexDateType = 0
      this.person=''
      this.startDate = formatDate(new Date(),-30).date
      this.endDate = formatDate().date
    },
    // 单选
    chooseApplyWay(index) {
      this.indexStatus = index
    },
    //单选   日期类型
    chooseDateType(index) {
      this.indexDateType = index 
    },
    //确认选中的过滤条件
    confirmFilter: function() {
      if(this.endDate< this.startDate) {
        this.$toast('结束日期早于开始日期！')
      } else {
        var status = this.indexStatus - 1 < 0 ? '' : this.indexStatus - 1
        var filterQuery = {
          status: status,
          dateType: this.indexDateType,
          dateBegin: this.startDate,
          dateEnd: this.endDate,
          ccr: this.person
        }
        this.$emit('selected', filterQuery)
        this.toggle()
      }
    },
    //点击 去获取日期
    showDate() {
      this.$refs.date.toggle({
        defaultDate:[this.startDate,this.endDate],
        minDate:this.minDate,
        maxDate:this.maxDate,
      })
    },
    getDate(date){//日期回调
      [this.startDate,this.endDate]=date
    },
    toggle(){
      this.isShow=!this.isShow
      if(this.isShow){
        this.init()
      }
    }
  },
}
</script>
<style lang="less">
.tripFilter-panel {
  .pad {
    padding: 10px 16px;
  }
  .pad-lr-8 {
    padding-left: 8px;
    padding-right: 8px;
  }

  .filter-right-item {
    width: 27%;
    margin-right: 6%;
    float: left;
    background-color: @color-background-white;
    border: 1px solid;
    border-radius: 2px;
    font-size: 0.24rem;
    text-align: center;
    padding: 0.1rem 0;
    margin: 0.1rem 6% 0.1rem 0;
  }

  .filter-right-item.active {
    color: @color-text-white;
    background-color: @color-background-main;
  }
}
</style>